export default "__VITE_ASSET__b787f41c__"